import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-10689c18"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "catchText likeP",
  href: "/search"
}, "求人検索", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "https://vets-index.com" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "logo",
    src: _imports_0,
    alt: "Vets Index"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_divider = _resolveComponent("n-divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_n_divider, {
      vertical: "",
      style: {"height":"1.2rem","--n-color":"#000","margin-top":"1rem"}
    }),
    _hoisted_3
  ]))
}